import React from 'react'
import useAntetrekPopup from 'hooks/useAntetrekPopup'

/**
 * Mounts the AnteTrek realtime popup widget lifecycle for the logged-in player.
 * Renders nothing; all behaviour lives in useAntetrekPopup.
 */
const AntetrekPopupWidget = () => {
  useAntetrekPopup()
  return null
}

export default React.memo(AntetrekPopupWidget)
